import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useDispatch, useSelector } from 'react-redux';
import { GetOneClientAction } from '../Redux/Actions/UsersAction';
import moment from 'moment';

export const SelectedLeadDuplicationPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetOneClientAction(id));
  }, [dispatch, id]);

  const resselectedlead = useSelector((state) => state.Allusers.Get_users);
  const leadData = resselectedlead?.data ?? {};
  const versions = leadData?.allVersions ?? [];

  // ترتيب النسخ حسب التاريخ
  const sortedVersions = [...versions].sort(
    (a, b) => new Date(a.recordedAt) - new Date(b.recordedAt),
  );
  const firstSubmission = sortedVersions[0];
  const lastSubmission = sortedVersions[sortedVersions.length - 1];

  // get all information about logged user
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);
  // تحديد الرابط المناسب حسب الدور
  const backLink =
    userlogin?.data?.role === 'Marketer'
      ? '/ALLLeadsForMarketer'
      : userlogin?.data?.role === 'Admin'
        ? '/AllLeads'
        : '/'; // رابط افتراضي في حالة الدور غير معروف

  return (
    <Container className="startpage ">
      <div className="mb-3">
        <Link to={backLink} style={{ textDecoration: 'none', color: '#0F7687' }}>
          <strong>
            {userlogin?.data?.role === 'Marketer' ? 'Leads For Marketer' : 'All Leads'}
          </strong>
        </Link>
        <KeyboardDoubleArrowRightIcon /> <span>Selected Lead Duplication</span>
      </div>

      <div className="mb-4">
        <h4>
          Duplicated Submissions for: <strong>{leadData?.name}</strong>
        </h4>
        <p>
          Total Submissions: <strong>{leadData?.totalSubmissions}</strong>
        </p>
      </div>

      <Row>
        {sortedVersions.map((ver, index) => (
          <Col md={6} lg={4} key={index} className="mb-4 fade-in">
            <div className="lead-card shadow-sm border-0 mx-2">
              <Card.Title className="text-primary mb-3">Submission #{index + 1}</Card.Title>
              <div className="mx-2">
                <p>
                  <strong>Name:</strong> {ver.name}
                </p>
                <p>
                  <strong>Email:</strong> {ver.email}
                </p>
                <p>
                  <strong>Phone:</strong> {ver.phone}
                </p>
                <p>
                  <strong>Recorded At:</strong> {moment(ver.recordedAt).format('YYYY-MM-DD HH:mm')}
                </p>
                <p>
                  <strong>Added By:</strong> {ver.addby?.name}
                </p>
                <p>
                  <strong>Project:</strong> {ver.project?.name}
                </p>
                <p>
                  <strong>Developer:</strong> {ver.project?.developer?.name}
                </p>
                <p>
                  <strong>Campaign:</strong> {ver.campaign?.CampainName}
                </p>
                <p>
                  <strong>Channel:</strong> {ver.chanel?.name}
                </p>
                <p>
                  <strong>Communication Way:</strong> {ver.communicationway?.name}
                </p>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {/* سطر في الأسفل لتوضيح أول وآخر تسجيل */}
      {firstSubmission && lastSubmission && (
        <div className="mt-4 p-3 bg-light border rounded">
          <p>
            <strong>First Registered By:</strong> {firstSubmission.addby?.name} on{' '}
            {moment(firstSubmission.recordedAt).format('YYYY-MM-DD HH:mm')}
          </p>
          <p>
            <strong>Last Registered By:</strong> {lastSubmission.addby?.name} on{' '}
            {moment(lastSubmission.recordedAt).format('YYYY-MM-DD HH:mm')}
          </p>
        </div>
      )}
    </Container>
  );
};
